import * as actionTypes from './actionTypes';

// Init state
export const servicesReportsState = {
  isLoading: false,
  data: [],
  filters: {},
  sort: {
    columns: [
      {
        name: 'count_orders',
        asc: 'count_orders',
        desc: 'count_orders-desc',
        active: null,
      },
      {
        name: 'charge',
        asc: 'charge',
        desc: 'charge-desc',
        active: null,
      },
      {
        name: 'cost',
        asc: 'cost',
        desc: 'cost-desc',
        active: null,
      },
      {
        name: 'profit',
        asc: 'profit',
        desc: 'profit-desc',
        active: 'desc',
      },
      {
        name: 'refunded',
        asc: 'refunded',
        desc: 'refunded-desc',
        active: null,
      },
    ],
  },
  init: false,
  error: null,
};

export const servicesReportsReducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
  case actionTypes.REPORTS_SERVICES_INIT:
    return {
      ...state,
      init: payload.init,
    }
  case actionTypes.REPORTS_SERVICES_LOADING:
    return {
      ...state,
      isLoading: payload,
    }
  case actionTypes.REPORTS_SERVICES_DATA_SUCCESS:
    return {
      ...state,
      isLoading: false,
      data: payload.data,
      filters: payload.filters,
    }
  case actionTypes.REPORTS_SERVICES_DATA_ERROR:
    return {
      ...state,
      error: payload.error,
    }
  case actionTypes.REPORTS_SERVICES_SORT:
    return {
      ...state,
      sort: {
        ...state.sort,
        columns: state.sort.columns.map((column) => {
          if (column.name === payload.column) {
            return {
              ...column,
              active: payload.active,
            }
          }
          return {
            ...column,
            active: null,
          }
        }),
      },
    }
  default:
    return { ...state };
  }
};
